module.exports = __webpack_public_path__ + "static/mh-2e9de882e64a76e54cfb62865c9ce53e.jpg";